/*jshint -W109 */
export default class ViewportUtility {

    constructor() {}

    static isPortait() {
        return ViewportUtility.width <= ViewportUtility.height;
    }

    static get pixelRatio() {
        return window.devicePixelRatio || 1;
    }

    static get breakpoint() {
        let value;
        let match;

        value = window.getComputedStyle(document.body, ':after').getPropertyValue('content');
        match = value.replace(/"/g, '');

        return match;
    }

    static get width() {
        return window.innerWidth || document.documentElement.clientWidth;
    }

    static get height() {
        return window.innerHeight || document.documentElement.clientHeight;
    }

    static get scrollX() {
        return (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    }

    static get scrollY() {
        return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }

    static scrollPosition() {
        return [
            typeof(window.pageXOffset) === 'number' ? window.pageXOffset : document.body && document.body.scrollLeft ? document.body.scrollLeft : document.documentElement && document.documentElement.scrollLeft ? document.documentElement.scrollLeft : null,
            typeof(window.pageYOffset) === 'number' ? window.pageYOffset : document.body && document.body.scrollTop ? document.body.scrollTop : document.documentElement && document.documentElement.scrollTop ? document.documentElement.scrollTop : null
        ];
    }

    static screenSize() {
        return [
            ViewportUtility.width,
            ViewportUtility.height
        ];
    }
}
